<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelProduto"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    :loading="isLoading"
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },

  props: {
    nameField: { type: String, default: null },
    isRequired: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    emptyLabel: { type: String, default: null },
    includeAll: { type: Boolean, default: false },
    isObject: { type: Boolean, default: false }
  },

  data() {
    return {
      selected: [],
      value: [],
      isLoading: false
    };
  },
  computed: {
    options() {
      let optionsProduto = [];

      if (this.includeAll) {
        optionsProduto.push({ id: null, nome: this.$i18n.t(this.emptyLabel) });
      }
      optionsProduto.push(
        { id: 'games', nome: 'Games' },
        { id: 'lotto', nome: 'Lotto' },
        { id: 'sportsbook', nome: 'SportsBook' }
      );
      return optionsProduto;
    }
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_produto', null);
        return;
      }
      if (this.isObject) {
        this.$emit('selectChange', 'id_produto', e);
      } else {
        this.$emit('selectChange', 'id_produto', e.id);
      }
    },
    setValue(value) {
      if (value) {
        if (value.id) {
          this.selected = this.options.find((option) => option.id === value.id);
        } else {
          this.selected = this.options.find((option) => option.id === value);
        }
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    labelProduto({ nome }) {
      return `${nome}`;
    }
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>
